// Seat links look like `http://host/#seat=player1&token=...` (docs/ui-v2-contract.md section 9).
// The token is moved into sessionStorage and the fragment is removed from the address bar.

export interface SeatCredential {
  seat: string;
  token: string;
}

export function credentialKey(path = ''): string {
  const game = /^\/rooms\/([^/]+)\/games\/([^/]+)/.exec(path);
  return game ? `bgc.seat.${game[1]}.${game[2]}` : 'bgc.seat';
}

export function parseFragment(hash: string): SeatCredential | null {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const seat = params.get('seat');
  const token = params.get('token');
  if (!seat || !token || !/^[0-9A-Fa-f]{64}$/.test(token)) return null;
  return { seat, token };
}

export function takeCredential(location: Location, history: History, storage: Storage | undefined, persist = true): SeatCredential | null {
  const key = credentialKey(location.pathname);
  const fromHash = parseFragment(location.hash);
  if (fromHash) {
    if (persist) try { storage?.setItem(key, JSON.stringify(fromHash)); } catch { /* storage may be unavailable */ }
    history.replaceState(null, '', location.pathname + location.search);
    return fromHash;
  }
  if (!persist) return null;
  try {
    const saved = storage?.getItem(key);
    if (saved) {
      const parsed = JSON.parse(saved) as SeatCredential;
      if (parsed && typeof parsed.seat === 'string' && typeof parsed.token === 'string') return parsed;
    }
  } catch { /* ignore corrupt storage */ }
  return null;
}

export function forgetCredential(storage: Storage | undefined, path = ''): void {
  try { storage?.removeItem(credentialKey(path)); } catch { /* ignore */ }
}
